<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
<path style="fill:#D80027;" d="M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256s256,0,256,0S449.761,256,512,256z"/>
<path style="fill:#0052B4;" d="M0,256C0,114.616,114.616,0,256,0c0,97.355,0,256,0,256S89.043,256,0,256z"/>
<polygon style="fill:#F0F0F0;" points="152.389,89.043 168.966,140.061 222.609,140.061 179.211,171.591 195.787,222.609 
	152.389,191.078 108.991,222.609 125.567,171.591 82.169,140.061 135.812,140.061 "/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
